/**
 * Import the Icons we use from FontAwesome package
 * @url https://fontawesome.com/
 */

import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {
    faFirstAid,
    faMapMarkerAlt,
    faLightbulb,
    faPhone,
    faCoffee,
    faParking,
    faCar,
    faWheelchair,
    faStore,
    faMap,
    faCalendar,
    faEnvelope,
    faHome,
    faShoppingCart,
    faTimes,
    faChevronRight,
    faChevronLeft,
    faPlus,
    faInfoCircle,
    faMinus,
    faTh,

} from '@fortawesome/free-solid-svg-icons'

library.add(
    faFirstAid,
    faMapMarkerAlt,
    faLightbulb,
    faPhone,
    faCoffee,
    faParking,
    faCar,
    faWheelchair,
    faStore,
    faMap,
    faCalendar,
    faEnvelope,
    faHome,
    faShoppingCart,
    faTimes,
    faChevronRight,
    faChevronLeft,
    faPlus,
    faInfoCircle,
    faTh,
    faMinus,
)

import {
    faFacebookF,
    faWhatsapp,
    faTwitter,
    faLinkedinIn,
    faInstagram,
} from '@fortawesome/free-brands-svg-icons'

library.add(faFacebookF, faWhatsapp, faTwitter, faLinkedinIn, faInstagram)

dom.watch()



// WEBPACK FOOTER //
// ./scripts/custom/icons.js